"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pre_chat_component_1 = require("./pre-chat.component");
var ɵ0 = [pre_chat_component_1.PreChatComponent];
exports.ɵ0 = ɵ0;
var PreChatAppModule = /** @class */ (function () {
    function PreChatAppModule() {
        var options = {
            failed: !!model.error,
            language: model.userLanguage,
            isPreChatForm: true,
            displaySettingId: model.displaySettingId,
            offlineTimeout: parseInt(model.customerTimeout) * 1000,
        };
        var prechat = new PreChat(options);
        prechat.init();
    }
    return PreChatAppModule;
}());
exports.PreChatAppModule = PreChatAppModule;
